import { graphql } from '../../graphql/graphql';

export const followPropertyV2Mutation = graphql(`
  mutation followPropertyV2($propertyId: String!, $propertyRelationship: PropertyRelationship!) {
    followPropertyV2(propertyId: $propertyId, propertyRelationship: $propertyRelationship) {
      _id
      followedProperties {
        id
        relationship
      }
    }
  }
`);
